module.exports = __webpack_public_path__ + "static/media/appLab_temperature_converter.d5a8713e.png";